'use client';

import { createContext } from 'react';

import type { AuthContextValue } from './auth-context-value';

// ----------------------------------------------------------------------

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
